import { fetchSingleProductByBarcode } from '@app/services/productsRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';
import { Id } from '@typings';

export const PRODUCT_BY_BARCODE_QUERY_KEY = 'PRODUCT_BY_BARCODE_QUERY_KEY';

export const useProductByBarcode = (barcode: Nullable<string>, deliveryWindows: Id[], buyerId: string | undefined) => {
  const isEnabled = isDefined(barcode);

  return useQuery({
    enabled: isEnabled,
    queryFn: isEnabled ? async () => fetchSingleProductByBarcode(barcode, deliveryWindows, buyerId) : skipToken,
    queryKey: [PRODUCT_BY_BARCODE_QUERY_KEY, { buyerId, deliveryWindows, productId: barcode }],
    refetchOnMount: false,
    retry: false,
  });
};
